import React from 'react';
import { ArchiveBoxIcon, XMarkIcon } from '@heroicons/react/24/outline';

const ConfirmArchiveModal = ({ isOpen, onClose, onConfirm, currentMonth, archiveResult }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <ArchiveBoxIcon className="h-8 w-8 text-orange-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-semibold text-gray-900">
                Архивировать выполненные задачи
              </h3>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {archiveResult ? (
            <div className="flex flex-col items-center justify-center">
              <ArchiveBoxIcon className="h-12 w-12 text-orange-500 mb-2" />
              <div className="text-base text-gray-800 font-semibold mb-2 text-center">
                {archiveResult}
              </div>
            </div>
          ) : (
            <>
              <div className="text-sm text-gray-600 mb-4">
                <p className="mb-2">
                  Вы собираетесь архивировать <strong>все выполненные задачи</strong> за:
                </p>
                <div className="bg-orange-50 border border-orange-200 rounded-md p-3">
                  <span className="text-orange-800 font-semibold text-base">
                    {currentMonth}
                  </span>
                </div>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-4">
                <p className="text-blue-800 text-sm">
                  <strong>Внимание:</strong> Это действие нельзя отменить. Задачи будут перемещены в архив и удалены из основного списка.
                </p>
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
          {archiveResult ? (
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-white bg-orange-600 border border-transparent rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
            >
              Закрыть
            </button>
          ) : (
            <>
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              >
                Отмена
              </button>
              <button
                onClick={onConfirm}
                className="px-4 py-2 text-sm font-medium text-white bg-orange-600 border border-transparent rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
              >
                Архивировать
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmArchiveModal; 